import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import es from 'vee-validate/dist/locale/es';

Vue.use(VeeValidate, {
    validity: true,
})

Validator.localize('es', {
    custom: {
        acepta_politicas: {
            required: 'Debes de aceptar las políticas de privacidad para poder continuar.'
        },
        acepta_terminos: {
            required: 'Debes de aceptar los términos y condiciones para poder crear una cuenta con nosotros.'
        },
        autoriza_consulta_buro: {
            required: 'Debe otorgar permiso para consultar su Buró de Crédito para continuar.'
        }
    }, 
    messages: {
        ... es.messages,
        decimal: (field) => `El campo ${field} debe ser numérico.`
    }
});

Validator.extend('max_money', {
    getMessage (field, args) {
        const [num] = args
        const mount = Vue.filter('currency')(num, '$ ', 0)
        return `El campo ${field} debe de ser de ${mount} o menor.`
    },
    validate (value, args) {
        // currency to number
        value = Number(value.replace(/[^0-9.-]+/g,""));
        return !isNaN(value) && value <= args[0]
    }
});

Validator.extend('min_money', {
    getMessage (field, args) {
        const [num] = args
        const mount = Vue.filter('currency')(num, '$ ', 0)
        return `El campo ${field} debe de ser de ${mount} o superior.`
    },
    validate (value, args) {
        // currency to number
        value = Number(value.replace(/[^0-9.-]+/g,""));
        return !isNaN(value) && value >= args[0]
    }
});

Validator.extend('max_files', {
    getMessage (field, args) {
        const [max] = args
        return `El numero de archivos ${field} debe ser ${max} o menor.`
    },
    validate (value, args) {
        const [max] = args
        return value.length > max;
    }
});

Validator.extend('min_files', {
    getMessage (field, args) {
        const [min] = args
        return `El numero de archivos ${field} debe ser ${min} o superior.`
    },
    validate (value, args) {
        const [min] = args
        return value.length > min;
    }
});

Validator.extend('count_files', {
    getMessage (field, args) {
        const [count] = args
        return `El numero de archivos ${field} debe ser ${count}.`
    },
    validate (value, args) {
        const [count] = args
        return value.length == count;
    }
});

Validator.extend('max_size_files', {
    getMessage (field, args) {
        const [max] = args
        return `No subas archivos con más de ${max}MB de peso.`
    },
    validate (value, args) {
        const [max] = args
        return value.filter(val => val.size / 1024 / 1024 > max).length === 0
    }
});